import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@core/core.module';
import { HttpErrorInterceptorProvider } from '@core/services/http-error-interceptor.service';
import { HttpTokenInterceptorProvider } from '@core/services/http-token-interceptor.service';
import { AuthConfigModule } from '@core/auth/auth.module';
import { CustomTranslateLoader } from '@core/services/custom-translate-loader.service';
import { I18N_APP_ID } from '@core/injection-tokens';
import { ConfigurationService } from '@shared/services/configuration.service';
import { SharedModule } from '@shared/shared.module';

import { ShellModule } from './shell/shell.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppMonitoringService } from '@app/core/services/app-monitoring.service';

import { version } from '../../package.json';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AuthConfigModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'it',
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient, ConfigurationService, I18N_APP_ID]
      }
    }),
    CoreModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    ShellModule
  ],

  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (configurationService: ConfigurationService) => () => configurationService.loadConfiguration(),
      deps: [ ConfigurationService ],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (monitoringService: AppMonitoringService) => () => monitoringService.setReleaseVersion(version),
      deps: [ AppMonitoringService ],
      multi: true
    },
    HttpErrorInterceptorProvider,
    HttpTokenInterceptorProvider,
    { provide: I18N_APP_ID, useValue: 'EOBI' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
